import { z } from 'zod';

export const PLACE_WORKBAY_USAGE_STATUSES = [
  'AVAILABLE',
  'IN_USE',
  'BLOCKED',
  'MAINTENANCE',
] as const;

export const CreatePlaceSectorBodySchema = z.object({
  slug: z.string().trim().min(1).max(80),
  name: z.string().trim().min(1).max(200),
  displayOrder: z.number().int().min(0).optional(),
});

export type CreatePlaceSectorBody = z.infer<typeof CreatePlaceSectorBodySchema>;

export const CreatePlaceSectorResponseSchema = z.object({
  sectorId: z.uuid(),
});

export type CreatePlaceSectorResponse = z.infer<typeof CreatePlaceSectorResponseSchema>;

export const CreatePlaceWorkbayBodySchema = z.object({
  name: z.string().trim().min(1).max(200),
  displayOrder: z.number().int().min(0).optional(),
});

export type CreatePlaceWorkbayBody = z.infer<typeof CreatePlaceWorkbayBodySchema>;

export const CreatePlaceWorkbayResponseSchema = z.object({
  workbayId: z.uuid(),
});

export type CreatePlaceWorkbayResponse = z.infer<typeof CreatePlaceWorkbayResponseSchema>;

export const PlaceWorkbayListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  active: z.boolean(),
  usageStatus: z.enum(PLACE_WORKBAY_USAGE_STATUSES),
  displayOrder: z.number().int(),
});

export type PlaceWorkbayListItem = z.infer<typeof PlaceWorkbayListItemSchema>;

export const PlaceSectorListItemSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  displayOrder: z.number().int(),
  active: z.boolean(),
  workbays: z.array(PlaceWorkbayListItemSchema),
});

export type PlaceSectorListItem = z.infer<typeof PlaceSectorListItemSchema>;

export const ListPlaceSectorsResponseSchema = z.object({
  items: z.array(PlaceSectorListItemSchema),
});

export type ListPlaceSectorsResponse = z.infer<typeof ListPlaceSectorsResponseSchema>;

export const DeactivatePlaceSectorResponseSchema = z.object({
  sectorId: z.uuid(),
});

export type DeactivatePlaceSectorResponse = z.infer<typeof DeactivatePlaceSectorResponseSchema>;

export const DeactivatePlaceWorkbayResponseSchema = z.object({
  workbayId: z.uuid(),
});

export type DeactivatePlaceWorkbayResponse = z.infer<typeof DeactivatePlaceWorkbayResponseSchema>;

export const WorkbayOccupancySummaryResponseSchema = z.object({
  total: z.number().int().nonnegative(),
  available: z.number().int().nonnegative(),
  inUse: z.number().int().nonnegative(),
  blocked: z.number().int().nonnegative(),
  maintenance: z.number().int().nonnegative(),
});

export type WorkbayOccupancySummaryResponse = z.infer<typeof WorkbayOccupancySummaryResponseSchema>;
